import {GET_NEARBY_CITY} from './actionTypes'

const initialState = {
  myData: '',
  isLoadingNearByCity: false,
  hasError: false,
  isFulfilled: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case `${GET_NEARBY_CITY}_PENDING`:
      return {
        ...state,
        isFulfilled: false,
        isLoadingNearByCity: true,
        hasError: false,
        myData: undefined,
      }

    case `${GET_NEARBY_CITY}_FULFILLED`:
      return {
        isFulfilled: true,
        isLoadingNearByCity: false,
        hasError: false,
        myData: action.payload.data,
      }

    case `${GET_NEARBY_CITY}_REJECTED`:
      return {
        isFulfilled: false,
        isLoadingNearByCity: false,
        hasError: true,
        myData: undefined,
      }

    default:
      return state
  }
}
